export default __webpack_public_path__ + "0a45b33b113b45fbd12b2f2d3c3e088e.png";